import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { PageState, PageStore } from './page.store';

@Injectable({ providedIn: 'root' })
export class PageQuery extends Query<PageState> {
  loading$ = this.select(({ loadersCount }) => loadersCount > 0);

  constructor(protected store: PageStore) {
    super(store);
  }
}
